import React from 'react';
import { useTranslation } from 'react-i18next';
import PreviewCard from '../PreviewCard';
import { clampPropertySizeInput, MAX_PROPERTY_SIZE } from '../types';

interface SizeStepProps {
  address: string;
  area: string;
  size: string;
  onSizeChange: (value: string) => void;
  onNext: () => void;
}

const SizeStep = ({ address, area, size, onSizeChange, onNext }: SizeStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="amp-step amp-step--size">
      <PreviewCard address={address} area={area} size={size.trim()} />

      <div className="amp-step__body">
        <h2 className="amp-step__question">{t('newLandingPage.addMyPlace.size.question')}</h2>
        <label className="amp-field">
          <span className="amp-field__label">{t('newLandingPage.addMyPlace.size.label')}</span>
          <input
            className="amp-field__input"
            type="number"
            inputMode="numeric"
            min={0}
            max={MAX_PROPERTY_SIZE}
            value={size}
            placeholder={t('newLandingPage.addMyPlace.size.placeholder')}
            onChange={(event) => onSizeChange(clampPropertySizeInput(event.target.value))}
            onKeyDown={(event) => {
              if (event.key === 'Enter') onNext();
            }}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        </label>
      </div>

      <div className="amp-step__footer">
        <button type="button" className={`amp-cta${!size ? ' amp-cta--hidden' : ''}`} onClick={onNext}>
          {t('common.next')}
        </button>
      </div>
    </div>
  );
};

export default SizeStep;
